import axios from 'axios';
import { createAsyncThunk, createSlice, isFulfilled, isPending, isRejected } from '@reduxjs/toolkit';
import { appendCriteriaEquals } from '@/shared/utils/spring-api';
import { villageDefaultValue } from '../model/village.model';
import { serializeAxiosError, resolveAsyncThunkErrorMessage } from './reducer.utils';
const apiUrl = '/api/villages';
const initialState = {
    loading: false,
    errorMessage: null,
    villages: [],
    village: villageDefaultValue,
    updating: false,
    updateSuccess: false,
    totalItems: 0,
};
export const getVillages = createAsyncThunk('villageManagement/fetch_villages', async (districtId) => {
    const q = new URLSearchParams();
    appendCriteriaEquals(q, 'districtId', districtId);
    const qs = q.toString();
    return axios.get(qs ? `${apiUrl}?${qs}` : apiUrl);
}, { serializeError: serializeAxiosError });
export const getVillage = createAsyncThunk('villageManagement/fetch_village', async (id) => axios.get(`${apiUrl}/${id}`), { serializeError: serializeAxiosError });
export const getVillageCount = createAsyncThunk('villageManagement/fetch_village_count', async (districtId) => {
    const q = new URLSearchParams();
    appendCriteriaEquals(q, 'districtId', districtId);
    const qs = q.toString();
    return axios.get(qs ? `${apiUrl}/count?${qs}` : `${apiUrl}/count`);
}, { serializeError: serializeAxiosError });
export const createVillage = createAsyncThunk('villageManagement/create_village', async (entity) => axios.post(apiUrl, entity), { serializeError: serializeAxiosError });
export const updateVillage = createAsyncThunk('villageManagement/update_village', async (entity) => {
    const result = await axios.put(`${apiUrl}/${entity.id}`, entity);
    return result;
}, { serializeError: serializeAxiosError });
export const patchVillage = createAsyncThunk('villageManagement/patch_village', async (entity) => {
    const { id, ...partial } = entity;
    const result = await axios.patch(`${apiUrl}/${id}`, partial);
    return result;
}, { serializeError: serializeAxiosError });
export const deleteVillage = createAsyncThunk('villageManagement/delete_village', async (id) => axios.delete(`${apiUrl}/${id}`), { serializeError: serializeAxiosError });
export const VillageManagementSlice = createSlice({
    name: 'villageManagement',
    initialState: initialState,
    reducers: {
        reset() {
            return initialState;
        },
    },
    extraReducers(builder) {
        builder
            .addCase(getVillage.fulfilled, (state, action) => {
            state.loading = false;
            state.village = action.payload.data;
        })
            .addCase(getVillageCount.fulfilled, (state, action) => {
            state.totalItems = action.payload.data;
        })
            .addCase(deleteVillage.fulfilled, (state) => {
            state.updating = false;
            state.updateSuccess = true;
            state.village = villageDefaultValue;
        })
            .addMatcher(isFulfilled(getVillages), (state, action) => {
            state.loading = false;
            state.villages = action.payload.data;
        })
            .addMatcher(isFulfilled(createVillage, updateVillage, patchVillage), (state, action) => {
            state.updating = false;
            state.updateSuccess = true;
            state.village = action.payload.data;
        })
            .addMatcher(isPending(getVillages, getVillage), (state) => {
            state.errorMessage = null;
            state.updateSuccess = false;
            state.loading = true;
        })
            .addMatcher(isPending(createVillage, updateVillage, patchVillage, deleteVillage), (state) => {
            state.errorMessage = null;
            state.updateSuccess = false;
            state.updating = true;
        })
            .addMatcher(isRejected(getVillages, getVillage, getVillageCount, createVillage, updateVillage, patchVillage, deleteVillage), (state, action) => {
            state.loading = false;
            state.updating = false;
            state.updateSuccess = false;
            state.errorMessage = resolveAsyncThunkErrorMessage(action.error);
        });
    },
});
export const { reset } = VillageManagementSlice.actions;
export default VillageManagementSlice.reducer;
